import {  Astro, PP, UserImage, Nort } from "../assets/images";

export const Member = [
    {
        img: Astro,
        name: "Akindele Samson Opeyemi",
    },
    {
        img: UserImage,
        name: "Akindele Samson Opeyemi",
    },
    {
        img: Astro,
        name: "Akindele Samson Opeyemi",
    },
    {
        img: PP,
        name: "Annie Bassy",
    },
    {
        img: UserImage,
        name: "Akindele Samson Opeyemi",
    },
    {
        img: PP,
        name: "Annie Bassy",
    },
    {
        img: Astro,
        name: "Akindele Samson Opeyemi",
    },
    {
        img: PP,
        name: "Annie Bassy",
    },
    {
        img: Nort,
        name: "Akindele Samson Opeyemi",
    },
    {
        img: UserImage,
        name: "Annie Bassy",
    },
    {
        img: Nort,
        name: "Akindele Samson Opeyemi",
    },
    {
        img: UserImage,
        name: "Annie Bassy",
    },
    {
        img: Nort,
        name: "Akindele Samson Opeyemi",
    },
];